(function () {
  const DEBUG_PREFETCH = false;

  const ALLOWED_PREFIXES = ['/products/', '/collections/', '/pages/', '/blogs/'];
  const BLOCKED_PREFIXES = [
    '/cart',
    '/checkout',
    '/account',
    '/login',
    '/search',
    '/apps',
    '/tools',
    '/challenge',
    '/recommendations',
    '/predictive-search',
    '/policies'
  ];
  const BLOCKED_EXTENSIONS = [
    '.jpg',
    '.jpeg',
    '.png',
    '.gif',
    '.webp',
    '.avif',
    '.svg',
    '.pdf',
    '.zip',
    '.mp4',
    '.mov',
    '.webm',
    '.css',
    '.js',
    '.json',
    '.xml'
  ];
  const MAX_PREFETCH = 5;
  const HOVER_DELAY = 100;

  function log() {
    if (DEBUG_PREFETCH && typeof console !== 'undefined' && console.log) {
      console.log.apply(console, ['[safe-prefetch]'].concat(Array.prototype.slice.call(arguments)));
    }
  }

  const probe = document.createElement('link');
  const supportsPrefetch = !!(
    probe.relList &&
    typeof probe.relList.supports === 'function' &&
    probe.relList.supports('prefetch')
  );
  if (!supportsPrefetch) {
    log('prefetch unsupported, aborting');
    return;
  }

  const connection =
    navigator.connection || navigator.mozConnection || navigator.webkitConnection || null;
  if (connection) {
    if (connection.saveData === true) {
      log('saveData enabled, aborting');
      return;
    }
    const effectiveType = connection.effectiveType;
    if (effectiveType === 'slow-2g' || effectiveType === '2g') {
      log('slow connection, aborting', effectiveType);
      return;
    }
  }

  const prefetched = new Set();
  const timers = new WeakMap();
  let prefetchCount = 0;

  function startsWithAny(path, list) {
    for (let i = 0; i < list.length; i++) {
      if (path.indexOf(list[i]) === 0) return true;
    }
    return false;
  }

  function endsWithAny(path, list) {
    for (let i = 0; i < list.length; i++) {
      if (path.length >= list[i].length && path.slice(-list[i].length) === list[i]) return true;
    }
    return false;
  }

  function isPrefetchable(anchor) {
    if (!anchor || !anchor.getAttribute || !anchor.getAttribute('href')) return null;
    let url;
    try {
      url = new URL(anchor.href, location.href);
    } catch (e) {
      return null;
    }
    url.hash = '';
    if (url.origin !== location.origin) return null;
    if (url.pathname === location.pathname) return null;
    if (url.search) return null;
    const path = url.pathname.toLowerCase();
    if (!startsWithAny(path, ALLOWED_PREFIXES)) return null;
    if (startsWithAny(path, BLOCKED_PREFIXES)) return null;
    if (endsWithAny(path, BLOCKED_EXTENSIONS)) return null;
    return url;
  }

  function performPrefetch(url) {
    if (prefetched.has(url.href)) return;
    if (prefetchCount >= MAX_PREFETCH) {
      log('max prefetch reached', url.href);
      return;
    }
    prefetched.add(url.href);
    prefetchCount += 1;
    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.as = 'document';
    link.href = url.href;
    document.head.appendChild(link);
    log('prefetched', url.href);
  }

  function getAnchor(event) {
    const target = event.target;
    if (!target || typeof target.closest !== 'function') return null;
    return target.closest('a[href]');
  }

  function schedule(event) {
    const anchor = getAnchor(event);
    if (!anchor) return;
    if (timers.has(anchor)) return;
    const url = isPrefetchable(anchor);
    if (!url) {
      log('skipped', anchor.href || '');
      return;
    }
    if (prefetched.has(url.href)) return;
    const timer = setTimeout(function () {
      timers.delete(anchor);
      performPrefetch(url);
    }, HOVER_DELAY);
    timers.set(anchor, timer);
  }

  function cancel(event) {
    const anchor = getAnchor(event);
    if (!anchor) return;
    const timer = timers.get(anchor);
    if (timer) {
      clearTimeout(timer);
      timers.delete(anchor);
    }
  }

  document.addEventListener('pointerenter', schedule, true);
  document.addEventListener('mouseover', schedule, true);
  document.addEventListener('touchstart', schedule, { capture: true, passive: true });
  document.addEventListener('focus', schedule, true);
  document.addEventListener('pointerleave', cancel, true);
  document.addEventListener('mouseout', cancel, true);
  document.addEventListener('blur', cancel, true);
})();

(function initTopshelfRewardsSocialLinks() {
  if (window.__topshelfRewardsSocialLinksBound) return;
  window.__topshelfRewardsSocialLinksBound = true;

  const SOCIAL_URLS = {
    'facebook-share': 'https://www.facebook.com/sharer/sharer.php?u=https://topshelfaquatics.com',
    'tiktok-follow': 'https://www.tiktok.com/@topshelfaquatics',
    'instagram-follow': 'https://www.instagram.com/topshelfaquatics/',
  };

  document.addEventListener('click', function (event) {
    const card = event.target.closest && event.target.closest('.topshelf-rewards-card[data-earn-rule-id]');
    if (!card) return;
    const url = SOCIAL_URLS[card.getAttribute('data-earn-rule-id')];
    if (!url) return;
    event.preventDefault();
    window.open(url, '_blank', 'noopener,noreferrer');
  });
})();
